import { useState } from 'react';
import { Button } from './Button';
import './components.css';

interface ExportButtonProps {
  onExport: (format: 'csv' | 'xlsx') => Promise<void>;
  label?: string;
  disabled?: boolean;
}

export function ExportButton({ onExport, label = 'Export', disabled }: ExportButtonProps) {
  const [format, setFormat] = useState<'csv' | 'xlsx'>('csv');
  const [isExporting, setIsExporting] = useState(false);

  async function handleClick() {
    setIsExporting(true);
    try {
      await onExport(format);
    } finally {
      setIsExporting(false);
    }
  }

    return (
    <div className="export-button">
      <Button
        variant="secondary"
        className="export-button__btn"
        onClick={() => void handleClick()}
        isLoading={isExporting}
        disabled={disabled}
      >
        {label}
      </Button>
      <select
        className="export-button__format"
        value={format}
        onChange={(e) => setFormat(e.target.value as 'csv' | 'xlsx')}
        aria-label="Export file format"
      >
        <option value="csv">CSV</option>
        <option value="xlsx">Excel</option>
      </select>
    </div>
  );
}